import InfiniteScrollStore from '@/store/modules/InfiniteScrollStore'

export interface TopUserState {
  activeTab: number
  distance: number
  entries: any[]
  gridEntries: any[]
  gridEntriesColumnIndex: number
  gridEntriesIndex: number
  topViewIcon: string
  topViewStyle: string
}

const defaultState = Object.assign(
  {
    activeTab: 0,
    distance: 1000,
    entries: [],
    gridEntries: [],
    gridEntriesColumnIndex: 0,
    gridEntriesIndex: 0,
    topViewIcon: 'view-list',
    topViewStyle: 'grid'
  },
  InfiniteScrollStore.defaultState
)

const state: TopUserState = Object.assign({}, defaultState)

const mutations = Object.assign(
  {
    resetState(state: TopUserState) {
      const s = defaultState
      Object.keys(s).forEach(key => {
        state[key] = s[key]
      })
    },
    setTopViewStyle(state: TopUserState, topViewStyle: 'grid' | 'list') {
      state.topViewStyle = topViewStyle
    },
    setTopViewIcon(state: TopUserState, topViewIcon: 'grid-view' | 'view-list') {
      state.topViewIcon = topViewIcon
    },
    setActiveTab(state: TopUserState, activeTab: number) {
      state.activeTab = activeTab
    }
  },
  InfiniteScrollStore.mutations
)

const actions = Object.assign({}, InfiniteScrollStore.actions)

const getters = Object.assign(
  {
    entries: (state: TopUserState): any[] => state.entries,
    gridEntries: (state: TopUserState): any[] => state.gridEntries,
    topViewStyle: (state: TopUserState): string => state.topViewStyle,
    topViewIcon: (state: TopUserState): string => state.topViewIcon,
    activeTab: (state: TopUserState): number => state.activeTab
  },
  InfiniteScrollStore.getters
)

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
